import { type GqlIdentity } from '../../../../graphql/base-types.graphql';
import { type ObjectInputForm } from '../../../../components/object-input/object-input.component';
import { JuridicalKind } from '../../../../models/identity.model';
import { formatIdNumber } from '@startuptools/common/id-number';

interface Party {
  model: Pick<GqlIdentity, 'isSwedish' | 'identityNumber' | 'id' | 'juridicalKind' | 'email' | 'emailMd5' | 'name'>;
  name: string;
  sub: string;
}

export class PartyObjectInputAdapter implements ObjectInputForm {
  constructor(public party: Party) {}

  get name() {
    return this.party.name;
  }

  // @ts-expect-error TS2416
  get sub() {
    if (this.party.model.isSwedish) {
      return formatIdNumber(this.party.model.identityNumber);
    }
    return formatIdNumber(this.party.sub);
    // return this.party.model.email;
  }

  get identityId() {
    return this.party.model?.id;
  }

  get gravatarEmail() {
    return this.party.model?.juridicalKind === JuridicalKind.Person ? this.party.model.email || '' : null;
  }

  get gravatarHash() {
    return this.party.model?.juridicalKind === JuridicalKind.Person ? this.party.model.emailMd5 || '' : null;
  }
}
